import React from 'react';

const ResetFilter = ({onReset}) => {
  const resetClick = e => {
    e.preventDefault();
    onReset && onReset();
  };

  return (
    <button className="reset-filter" onClick={resetClick}>Reset Filters</button>
  );
};

export default ResetFilter;